<ng-container>
	<router-outlet></router-outlet>
</ng-container>

<!-- <ng-container *ngIf="viewMode == eViewMode.Dashboard">
	<nav></nav>
	<main>
		<div left>
			<mat-list>
				<div mat-subheader>Rezultatele verificării</div>
				<mat-list-item [routerLink]="'report/'+this.router.url">
					<button mat-raised-button
						style="width: 100%;"
						[routerLink]="'report/'+this.router.url"
						color="primary">Apasă aici</button>
				</mat-list-item>
				<mat-list-item [routerLink]="'demo2/filter'">
					<button mat-raised-button
									style="width: 100%;"
									[routerLink]="'demo2/filter'"
									color="warn">Include Filter</button>
				</mat-list-item>
				<mat-list-item [routerLink]="'demo1/uxuiglpkdgr3wop9'">
					<button mat-raised-button
									style="width: 100%;"
									[routerLink]="'demo1/uxuiglpkdgr3wop9'"
									color="warn">Include Alerts</button>
				</mat-list-item>
				<mat-list-item routerLink="main">
					<button mat-raised-button
									style="width: 100%;"
									routerLink="main">Main Page</button>
				</mat-list-item>
			</mat-list>
		</div>
		<div right>
		</div>
	</main>
	<router-outlet></router-outlet>
</ng-container>

<ng-container *ngIf="viewMode == eViewMode.Fullscreen">
	<router-outlet></router-outlet>
</ng-container> -->
